import React, {FC, memo, useState} from 'react'
import {FailedLinkStatus} from "@/src/components/OrderAuthModal/model";
import {Box, Button, Modal, Stack, Typography} from "@mui/material";
import Image from "next/image";
import {useRouter} from "next/navigation";



const CONTENT = {
    "expired": { title: "Термін дії посилання закінчився!", description: "Шановний клієнте! Термін дії цього посилання закінчився. Щоб придбати страховий поліс, будь ласка, перейдіть на сайт магазину і розпочніть оформлення заново. Дякуємо за розуміння!"},
    "not-found": { title: "Замовлення не знайдено!", description: "Шановний клієнте! Замовлення за вашим посиланням не знайдено. Щоб придбати страховий поліс, будь ласка, перейдіть на сайт магазину і розпочніть оформлення заново. Дякуємо за розуміння!"}
} as Record<FailedLinkStatus, { title: string; description: string }>
interface NotFoundLinkProps {
    processInstanceId: FailedLinkStatus,
    customContent?: { title: string; description: string },
    onCancel: () => void
}

const FailedLinkModal: FC<NotFoundLinkProps> = ({ processInstanceId, customContent, onCancel}) => {
    const router = useRouter();

    const modalContent = customContent ?? CONTENT[processInstanceId];

    const handleAccept = () => {
        router.push('/');
    }

    return (
        <Modal open={true} onClose={onCancel}>
            <Stack className="flex w-full max-w-[524px] flex-col items-center gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
                <Box>
                    <Image
                        width={80}
                        height={80}
                        src={"/images/warning_sign.png"}
                        alt="Попередження!"
                    />
                </Box>
                <Typography
                    component={"h4"}
                    className="text-lg font-semibold text-dark-gray"
                >
                    { modalContent.title }
                </Typography>
                <Typography
                    component={"h4"}
                    className="text-[15px] font-normal text-dark-gray text-center"
                >
                    { modalContent.description }
                </Typography>
                <Stack className="flex-center-row w-full gap-3">
                    <Button onClick={handleAccept} variant="contained" className="w-full" size='large'>
                        {"До магазину"}
                    </Button>
                </Stack>
            </Stack>
        </Modal>
    )
}

export default memo(FailedLinkModal)
